// extracted by mini-css-extract-plugin
export default {"settings":"TypeList_settings__nwL+h"};